<template>
  <div class="full-height">
    <q-card class="full-width full-height">
      <q-card-actions class="bg-accent text-white q-pa-md">
        <div class="title" style="width: 680px">
          {{ formData.title ? formData.title : "Articles" }}
        </div>
        <q-space></q-space>
        <q-btn
          @click="previewArticle"
          class="q-mr-sm sustainability-button bg-info"
          style="width: 100px"
        >
          Preview
        </q-btn>
        <q-btn
          class="q-mr-sm sustainability-button"
          :loading="isLoading"
          style="width: 100px; background-color: #6dbf50"
          @click="saveAndAddNew"
        >
          Save & Add New
        </q-btn>
        <q-btn
          color="primary"
          style="width: 100px"
          :loading="isLoading"
          class="q-mr-sm sustainability-button"
          @click="save(true)"
        >
          Save & Close
        </q-btn>
        <q-btn @click="closeDialog" flat icon="mdi-close" size="5" round />
      </q-card-actions>
      <q-tabs v-model="tab" align="left">
        <q-tab v-for="(tabItem, i) in tabsList" :key="i" :name="tabItem.name">
          <div style="display: inline">
            <span class="tabTitle">{{ tabItem.label }} </span>
            <q-icon name="mdi-alert-circle" color="red" v-if="tabItem.isError">
            </q-icon>
          </div>
        </q-tab>
      </q-tabs>
      <q-card-section>
        <q-tab-panels v-model="tab" animated keep-alive ref="tabs">
          <!--GENERAL-->
          <q-tab-panel name="general">
            <div class="row items-center">
              <div class="title q-my-none">Info</div>
            </div>
            <q-form ref="form">
              <div class="row justify-between q-mb-md">
                <div>
                  <span class="text-bold"> Article ID: </span>
                  {{ formData.id }}
                </div>
                <div>
                  <span class="float-right date">
                    {{ formData.created_at | generalDateFormat }}
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="q-mr-lg">
                  <div
                    v-if="(changeImage || !formData.imageUrl) && formData.id"
                    style="width: 200px"
                  >
                    <croppa
                      ref="imgCroppa"
                      :height="200"
                      :width="300"
                      v-model="myCroppa"
                      remove-button-color="#68c6d2"
                      :show-loading="true"
                      :loading-size="50"
                      crossOrigin="anonymous"
                      :quality="2"
                      :prevent-white-space="false"
                    ></croppa>
                    <span class="text-caption"
                      >Recommended .jpg/.jpeg files and ideally 500Kb
                    </span>
                  </div>
                  <div v-else style="margin: auto; width: 300px">
                    <q-img
                      :src="formData.imageUrl"
                      style="width: 300px; height: 200px"
                      v-if="formData.id"
                    >
                    </q-img>
                    <q-btn
                      class="full-width"
                      color="primary"
                      label="Change"
                      @click="changeImage = true"
                      v-if="formData.id"
                    >
                    </q-btn>
                    <span class="text-caption"
                      >Recommended .jpg/.jpeg files and ideally 500Kb
                    </span>
                  </div>
                </div>
                <div class="col-8">
                  <div class="row q-col-gutter-x-md q-col-gutter-y-xl">
                    <div class="col-4">
                      <q-input
                        v-model="formData.title"
                        label="Title"
                        :rules="[(v) => !!v || 'Field is Required']"
                      >
                      </q-input>
                    </div>
                    <div class="col-4">
                      <q-input
                        v-model="formData.author"
                        label="Author"
                        :rules="[(v) => !!v || 'Field is Required']"
                      >
                      </q-input>
                    </div>
                    <div class="col-4">
                      <q-input
                        readonly
                        v-model="totalReadMinutes"
                        label="Total reading minutes"
                      >
                      </q-input>
                    </div>
                    <div class="col-6">
                      <q-select
                        v-model="formData.outcomes_id"
                        label="Outcome"
                        :options="outcomesList"
                        map-options
                        hint="This is the primary Outcome, the article will be tagged under."
                        option-value="id"
                        option-label="name"
                        emit-value
                        :rules="[(v) => !!v || 'Field is Required']"
                      >
                      </q-select>
                    </div>
                    <div class="col-6">
                      <q-select
                        label="Progress Status"
                        v-model="formData.progressStatus"
                        :options="progressStatusOptions"
                        map-options
                        option-value="color"
                        option-label="label"
                        emit-value
                      >
                        <template v-slot:option="scope">
                          <q-item
                            dense
                            clickable
                            :active="scope.selected"
                            active-class="bg-primary"
                            @click="scope.toggleOption(scope.opt)"
                            v-bind="scope.itemProps"
                            v-on="scope.progressStatusOptions"
                          >
                            <q-item-section avatar>
                              <q-avatar>
                                <q-img
                                  :style="`background-color: ${scope.opt.color};width: 20px;height: 20px; border-radius: 100px;`"
                                ></q-img>
                              </q-avatar>
                            </q-item-section>
                            <q-item-section side style="color: black">
                              {{ scope.opt.description }}
                            </q-item-section>
                          </q-item>
                        </template>
                        <template v-slot:selected-item="scope">
                          <div class="row items-center">
                            <q-img
                              class="q-mr-md"
                              :style="`background-color: ${scope.opt.color};width: 20px;height: 20px; border-radius: 100px;`"
                            ></q-img>
                            {{ scope.opt.description }}
                          </div>
                        </template>
                      </q-select>
                    </div>
                  </div>
                </div>
              </div>
            </q-form>
          </q-tab-panel>
          <!--DESCRIPTION-->
          <q-tab-panel name="description">
            <div class="row justify-center">
              <span class="text-grey-6">
                The width here is based on the width of the article card
              </span>
            </div>
            <div class="row justify-center">
              <tiptap
                v-model="formData.description"
                class="q-px-lg q-py-md q-mx-auto"
                contentWidth="650px"
                barWidth="800px"
                borderWidth="700px"
              />
            </div>
          </q-tab-panel>
          <!--LINKS-->
          <q-tab-panel name="links">
            <div class="row items-center justify-between q-mb-md">
              <div>
                <div class="row items-center">
                  <div class="title q-my-none q-mx-none">Links</div>
                  <div class="q-mx-md">
                    <q-input label="Link Url" dense v-model="linkFormData.url">
                    </q-input>
                  </div>
                  <div>
                    <q-btn
                      color="primary"
                      @click="createLink"
                      :disable="!linkFormData.url"
                    >
                      <q-icon name="mdi-plus-circle"> </q-icon>
                      <span class="sustainability-font q-mx-sm"> Add </span>
                    </q-btn>
                  </div>
                </div>
              </div>
              <div>
                <q-input
                  class="searchbar float-right"
                  style="max-width: 70%"
                  filled
                  v-model="searchLinks"
                  debounce="200"
                  label="Search"
                  clearable
                  dense
                >
                  <template #prepend>
                    <q-icon name="mdi-magnify"></q-icon>
                  </template>
                </q-input>
              </div>
            </div>
            <div class="row">
              <sustainability-data-table
                style="height: calc(100vh - 350px)"
                flat
                headerBgColor="#162c47"
                headerTextColor="white"
                :columns="linksColumns"
                :data="links"
              >
                <template slot="body-cell-link" slot-scope="data">
                  <q-td :props="data.props">
                    <q-input
                      v-model="data.props.row.url"
                      @blur="saveLink(data.props.row)"
                      dense
                      label="Link"
                    >
                    </q-input>
                  </q-td>
                </template>
                <template slot="body-cell-actions" slot-scope="data">
                  <q-td :props="data.props">
                    <q-btn
                      round
                      color="red"
                      flat
                      icon="mdi-delete"
                      @click="removeLink(data.props.row)"
                      size="md"
                      class="float-right"
                    >
                      <q-tooltip content-class="bg-accent" :offset="[10, 10]">
                        Remove Link
                      </q-tooltip>
                    </q-btn>
                  </q-td>
                </template>
              </sustainability-data-table>
            </div>
          </q-tab-panel>
          <!--KEYWORDS-->
          <q-tab-panel name="keywords">
            <div class="row items-center justify-between q-mb-md">
              <div>
                <div class="row items-center">
                  <div class="title q-my-none q-mx-none">Keywords</div>
                  <div class="q-mx-md">
                    <q-select
                      label="Keyword"
                      dense
                      v-model="selectedKeyword"
                      use-input
                      hide-selected
                      fill-input
                      map-options
                      option-label="keyword"
                      @input-value="checkKeywordField"
                      option-value="id"
                      emit-value
                      @filter="keywordFilter"
                      :options="filteredKeywordSelectOptions"
                    >
                      <template v-slot:no-option>
                        <q-item>
                          <q-item-section class="text-grey">
                            No results
                          </q-item-section>
                        </q-item>
                      </template>
                    </q-select>
                  </div>
                  <div>
                    <q-btn
                      color="primary"
                      @click="addKeyword"
                      :disable="!selectedKeyword"
                    >
                      <q-icon name="mdi-plus-circle"> </q-icon>
                      <span class="sustainability-font q-mx-sm"> Add </span>
                    </q-btn>
                  </div>
                </div>
              </div>
              <div>
                <q-input
                  class="searchbar float-right"
                  style="max-width: 70%"
                  filled
                  v-model="searchKeywords"
                  debounce="200"
                  label="Search"
                  clearable
                  dense
                >
                  <template #prepend>
                    <q-icon name="mdi-magnify"></q-icon>
                  </template>
                </q-input>
              </div>
            </div>
            <div class="row">
              <sustainability-data-table
                style="height: calc(100vh - 350px)"
                flat
                headerBgColor="#162c47"
                headerTextColor="white"
                :columns="keywordsColumns"
                :data="articlesKeywords"
                :cellBodyStyle="cellBodyStyle"
              >
                <template slot="body-cell-keyword" slot-scope="data">
                  <q-td :props="data.props">
                    <q-input
                      v-model="data.props.row.keyword"
                      @blur="saveKeyword(data.props.row)"
                      dense
                      label="Keyword"
                    >
                    </q-input>
                  </q-td>
                </template>
                <template slot="body-cell-actions" slot-scope="data">
                  <q-td :props="data.props">
                    <q-btn
                      round
                      color="red"
                      flat
                      icon="mdi-delete"
                      @click="removeKeyword(data.props.row)"
                      size="md"
                      class="float-right"
                    >
                      <q-tooltip content-class="bg-accent" :offset="[10, 10]">
                        Remove Keyword
                      </q-tooltip>
                    </q-btn>
                  </q-td>
                </template>
              </sustainability-data-table>
            </div>
          </q-tab-panel>
          <!--SOLUTIONS-->
          <q-tab-panel name="solutions">
            <div class="row items-center justify-between q-mb-md">
              <div>
                <div class="row items-center">
                  <div class="title q-my-none q-mx-none">Solutions</div>
                  <div class="q-mx-md">
                    <q-select
                      style="width: 300px"
                      label="Solutions"
                      :options="filteredSolutionsSelectOptions"
                      dense
                      map-options
                      use-input
                      hide-selected
                      fill-input
                      :disable="articlesSolutionsList.length >= 4"
                      option-label="title"
                      option-value="id"
                      emit-value
                      v-model="selectedSolution"
                      @filter="solutionFilter"
                    >
                      <template v-slot:no-option>
                        <q-item>
                          <q-item-section class="text-grey">
                            No results
                          </q-item-section>
                        </q-item>
                      </template>
                    </q-select>
                  </div>
                  <div>
                    <q-btn
                      color="primary"
                      @click="addSolution"
                      :disable="
                        !selectedSolution || articlesSolutionsList.length >= 4
                      "
                    >
                      <q-icon name="mdi-plus-circle"> </q-icon>
                      <span class="sustainability-font q-mx-sm"> Add </span>
                    </q-btn>
                  </div>
                </div>
              </div>
              <div>
                <q-input
                  class="searchbar float-right"
                  style="max-width: 70%"
                  filled
                  v-model="searchSolutions"
                  debounce="200"
                  label="Search"
                  clearable
                  dense
                >
                  <template #prepend>
                    <q-icon name="mdi-magnify"></q-icon>
                  </template>
                </q-input>
              </div>
            </div>
            <div class="row">
              <sustainability-data-table
                style="height: calc(100vh - 350px)"
                flat
                headerBgColor="#162c47"
                headerTextColor="white"
                :columns="solutionsColumns"
                :data="articlesSolutionsList"
                :cellBodyStyle="cellBodyStyle"
              >
                <template slot="body-cell-rank" slot-scope="data">
                  <q-td :props="data.props">
                    <q-input
                      type="number"
                      v-model="data.props.row.rank"
                      @blur="saveSolution(data.props.row)"
                      dense
                      label="Rank"
                    >
                    </q-input>
                  </q-td>
                </template>
                <template slot="body-cell-actions" slot-scope="data">
                  <q-td :props="data.props">
                    <q-btn
                      round
                      color="red"
                      flat
                      icon="mdi-delete"
                      @click="removeSolution(data.props.row)"
                      size="md"
                      class="float-right"
                    >
                      <q-tooltip content-class="bg-accent" :offset="[10, 10]">
                        Remove Solution
                      </q-tooltip>
                    </q-btn>
                  </q-td>
                </template>
              </sustainability-data-table>
            </div>
          </q-tab-panel>
        </q-tab-panels>
      </q-card-section>
    </q-card>
    <q-dialog v-model="researchAndInsightsDialog" persistent>
      <research-and-insights-dialog
        @closeDialog="closeResearchAndInsightsDialog"
        :preview="true"
      ></research-and-insights-dialog>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import sustainabilityDataTable from "@/components/datatable/sustainabilityDatatable";
import tiptap from "@/components/tiptap/tiptap.vue";
import researchAndInsightsDialog from "@/components/researchAndInsights/researchAndInsightsDialog.vue";
export default {
  components: {
    sustainabilityDataTable,
    tiptap,
    researchAndInsightsDialog,
  },
  data: () => ({
    isLoading: false,
    formData: {},
    progressStatusOptions: [
      {
        color: "red",
        description: "Draft",
        label: "Red",
      },
      {
        color: "orange",
        description: "Complete but needs Revision",
        label: "Orange",
      },
      {
        color: "green",
        description: "Complete and live",
        label: "Green",
      },
    ],

    //tabs
    tab: "general",

    tabsList: [
      {
        name: "general",
        label: "Info",
        isError: false,
      },
      {
        name: "description",
        label: "Description",
        isError: false,
      },
      {
        name: "links",
        label: "Links",
        isError: false,
      },
      {
        name: "keywords",
        label: "Keywords",
        isError: false,
      },
      {
        name: "solutions",
        label: "Suggested Solutions",
        isError: false,
      },
      // {
      //   name: "preview",
      //   label: "Preview",
      //   isError: false,
      // },
    ],

    //croppa
    myCroppa: {},
    changeImage: false,

    //links
    searchLinks: "",
    linkFormData: {
      url: "",
    },

    //keywords
    searchKeywords: "",
    keywordSelectOptions: [],
    selectedKeyword: null,

    //solutions
    searchSolutions: "",
    solutionsSelectOptions: [],
    selectedSolution: null,

    //preview
    researchAndInsightsDialog: false,
  }),
  computed: {
    ...mapGetters({
      outcomesList: "outcomes/list",
      data: "articles/selectedArticle",
      links: "articles/links/list",
      keywords: "keywords/list",
      articlesKeywords: "articles/keywords/list",
      solutionsList: "solutions/list",
      articlesSolutionsList: "articles/solutions/list",
    }),
    cellBodyStyle() {
      return "font-family: 'Montserrat';font-style: normal;font-weight: 400;font-size: 14px;line-height: 17px;display: flex;align-items: center;letter-spacing: -0.02em;color: black;";
    },
    filteredKeywordSelectOptions() {
      let filteredKeywords = this.keywordSelectOptions;

      filteredKeywords = filteredKeywords.filter((e) => {
        if (
          this.articlesKeywords.findIndex((ak) => e.id == ak.keyword_id) < 0
        ) {
          return e;
        }
      });
      return filteredKeywords;
    },
    filteredSolutionsSelectOptions() {
      let filteredSolutions = this.solutionsSelectOptions;
      filteredSolutions = filteredSolutions.filter((e) => {
        if (
          this.articlesSolutionsList.findIndex(
            (as) => e.id == as.solutions_id
          ) < 0
        ) {
          return e;
        }
      });
      return filteredSolutions;
    },
    solutionsColumns() {
      return [
        {
          name: "id",
          label: "ID",
          align: "left",
          field: "id",
          style:
            "min-width: 60px;max-width: 60px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "rank",
          label: "Rank",
          align: "left",
          field: "rank",
          style:
            "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "title",
          label: "Solution Title",
          align: "left",
          field: "title",
          style:
            "min-width:300px;max-width:300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "createdAt",
          label: "Created At",
          align: "left",
          field: "created_at",
          format: (val) => {
            return this.$options.filters.gridDateFormat(val);
          },
          style:
            "min-width:300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "right",
          style:
            "min-width:300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
      ];
    },
    keywordsColumns() {
      return [
        {
          name: "id",
          label: "ID",
          align: "left",
          field: "id",
          style:
            "min-width: 20px;max-width: 20px;width: 20px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sorted: true,
        },
        {
          name: "keyword",
          label: "Keyword",
          align: "left",
          field: "keyword",
          style:
            "min-width: 200px;max-width: 200px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sorted: true,
        },
        {
          name: "createdAt",
          label: "Created At",
          align: "left",
          field: "created_at",
          format: (val) => this.$options.filters.gridDateFormat(val),
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sorted: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "right",
          field: "delete",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sorted: true,
        },
      ];
    },
    linksColumns() {
      return [
        {
          name: "id",
          label: "ID",
          align: "left",
          field: "id",
          style:
            "min-width: 20px;max-width: 20px;width: 20px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sorted: true,
        },
        {
          name: "link",
          label: "Link",
          align: "left",
          field: "url",
          style:
            "min-width: 200px;max-width: 200px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sorted: true,
        },
        {
          name: "createdAt",
          label: "Created At",
          align: "left",
          field: "created_at",
          format: (val) => this.$options.filters.gridDateFormat(val),
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sorted: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "right",
          field: "delete",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sorted: true,
        },
      ];
    },
    totalReadMinutes() {
      let totalMinutes = 0;
      if (this.formData.description) {
        let totalWordsOfDescription =
          this.formData.description.split(" ").length;
        totalMinutes =
          parseFloat((totalWordsOfDescription / 200).toFixed(0)) <= 0.0
            ? 0
            : (totalWordsOfDescription / 200).toFixed(0);
      } else {
        totalMinutes = 0;
      }
      this.formData.totalReadMins = parseFloat(totalMinutes);
      return totalMinutes;
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.init();
      },
    },
    $route: {
      deep: true,
      handler() {
        this.handleRoute();
      },
    },
  },
  mounted() {
    this.$store.dispatch("outcomes/loadAll");
    this.keywordSelectOptions = this.keywords;
    this.solutionsSelectOptions = this.solutionsList;
  },

  methods: {
    closeResearchAndInsightsDialog() {
      this.researchAndInsightsDialog = false;
    },
    closeDialog() {
      this.$router.push("/researchAndInsightsView/" + this.$route.params.id);
      this.researchAndInsightsDialog = false;
    },
    previewArticle() {
      this.researchAndInsightsDialog = true;
    },

    checkKeywordField(val) {
      if (typeof val === "string") {
        this.selectedKeyword = val;
      }
      if (typeof val === "object") {
        this.selectedKeyword = val.id;
      }
    },
    keywordFilter(val, update, abort) {
      update(() => {
        const input = val.toLowerCase();
        this.keywordSelectOptions = this.keywords.filter(
          (e) => e.keyword.toLowerCase().indexOf(input) > -1
        );
      });
    },
    solutionFilter(val, update, abort) {
      update(() => {
        const input = val.toLowerCase();
        this.solutionsSelectOptions = this.solutionsList.filter(
          (e) => e.title.toLowerCase().indexOf(input) > -1
        );
      });
    },
    init() {
      if (this.data != null) {
        this.formData = JSON.parse(JSON.stringify(this.data));
      }
      if (this.formData.status == "temp") {
        this.formData.status = "live";
      }
    },
    async saveSolution(payload) {
      let result = await this.$store.dispatch(
        "articles/solutions/save",
        payload
      );
      if (result.Result == "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: result.Response.Message,
        });
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
    },
    async addSolution() {
      let payload = {
        solutions_id: this.selectedSolution,
        articles_id: this.formData.id,
      };
      let result = await this.$store.dispatch(
        "articles/solutions/new",
        payload
      );

      if (result.Result == "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: result.Response.Message,
        });
        this.selectedSolution = "";
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
    },
    async addKeyword() {
      let result = null;
      if (typeof this.selectedKeyword === "string") {
        result = await this.$store.dispatch(
          "articles/keywords/newAndAssignKeyword",
          {
            keyword: this.selectedKeyword,
            articles_id: this.formData.id,
          }
        );
      } else if (typeof this.selectedKeyword === "number") {
        result = await this.$store.dispatch("articles/keywords/new", {
          articles_id: this.formData.id,
          keyword_id: this.selectedKeyword,
        });
      }

      if (result.Result == "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: result.Response.Message,
        });
        this.selectedKeyword = "";
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
    },
    async saveKeyword(payload) {
      let result = await this.$store.dispatch(
        "articles/keywords/save",
        payload
      );
      if (result.Result == "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: result.Response.Message,
        });
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
    },
    removeKeyword(keyword) {
      this.$swal({
        title: "Warning",
        text: "You are about to delete this Item. This is irreversible",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122",
      }).then(async (res) => {
        if (res.value) {
          let payload = {
            ...keyword,
          };
          payload.deleted_at = true;
          this.saveKeyword(payload);
        }
      });
    },
    async removeSolution(articlesSolution) {
      this.$swal({
        title: "Warning",
        text: "You are about to delete this Item. This is irreversible",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122",
      }).then(async (res) => {
        if (res.value) {
          let payload = {
            ...articlesSolution,
            deleted_at: true,
          };

          let result = await this.$store.dispatch(
            "articles/solutions/save",
            payload
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      });
    },

    async createLink() {
      let result = await this.$store.dispatch("articles/links/new", {
        articles_id: this.formData.id,
        ...this.linkFormData,
      });
      if (result.Result == "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: result.Response.Message,
        });
        this.linkFormData.url = "";
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
    },
    removeLink(link) {
      this.$swal({
        title: "Warning",
        text: "You are about to delete this Item. This is irreversible",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122",
      }).then(async (res) => {
        if (res.value) {
          let payload = {
            ...link,
          };
          payload.deleted_at = true;
          this.saveLink(payload);
        }
      });
    },
    async saveLink(link) {
      let result = await this.$store.dispatch("articles/links/save", link);
      if (result.Result == "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: result.Response.Message,
        });
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
    },
    async saveAndAddNew() {
      this.isLoading = true;
      await this.save();
      let result = await this.$store.dispatch("articles/new", {
        status: "temp",
      });
      let id = result.Response.newArticleId;
      this.$router.push("/artices/" + parseFloat(id));
      this.$store.dispatch("articles/loadByID", id);
    },
    async save(isClose = false) {
      const isValid = await this.$refs.form.validate();
      let index = this.tabsList.findIndex((e) => e.name == "general");

      if (isValid) {
        if (index > -1) {
          this.tabsList[index].isError = false;
        }
        let payload = {
          id: this.$route.params.id,
          ...this.formData,
        };

        //image uploading
        if (this.myCroppa && this.myCroppa.imageSet) {
          payload.image = {
            dataUrl: this.myCroppa.generateDataUrl(),
          };
        } else {
          delete payload.image;
        }

        let result = await this.$store.dispatch("articles/save", payload);
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
          if (isClose) {
            this.closeDialog();
          }
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      } else {
        if (index > -1) {
          this.tabsList[index].isError = true;
        }
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.date {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 13px;
}

.sustainability-button {
  min-width: 151px;
  height: 34px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 9px;
  line-height: 11px;
  display: flex;
  align-items: center;
  text-align: center;
}
.sustainability-font {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
}

.tabTitle {
  font-weight: bold;
}
</style>
